import React, { useEffect, useState, useContext, useRef } from 'react'
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import io from 'socket.io-client';
import axios from 'axios'
import SideNavMob from './SideNavMob'
import RightNavMob from './RightNavMob'
import NavBarMobile from './Mobile/NavBar'
import upload from './images/icons/image-.png'
import cam from './images/icons/cam.png'
import { DBContext } from './DBContext'
import Lottie from "lottie-react";
import loadingLottie from './images/lotties/loading.json'
import { useNavigate } from 'react-router-dom';
import cross from './images/icons/cross.png'
import { ToastContainer, toast } from 'react-toastify';
import noImage from './images/icons/depositphotos_247872612-stock-illustration-no-image-available-icon-vector.jpg'

function SoftwareSettings() {

    const { logginedDB, companyDetails } = useContext(DBContext);
    // console.log(companyDetails, "companyDetails in settings");
    
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    // Store initial PrintPreview value to detect changes
    const [initialPrintPreview, setInitialPrintPreview] = useState(0);
    const [companyInfo, setCompanyInfo] = useState({});

    const previewFromDB = companyInfo.PrintPreview
    const [checkboxValue, setCheckboxValue] = useState(previewFromDB || 0) // 0 = unchecked, 1 = checked
    
    // New state for General Settings
    const [taxGroups, setTaxGroups] = useState([]);
    const [genSettings, setGenSettings] = useState({
        Default_Tax_Id: null,
        isTaxInclusive: 0,
        Tax_Mode: 'ITEM_DETAIL',
        Print_Size: '80mm'
    });

    useEffect(() => {
        if (companyDetails) {
            setCompanyInfo(companyDetails);
            setInitialPrintPreview(companyDetails.PrintPreview || 0);
        }
    }, [companyDetails]);

    useEffect(() => {
        if (logginedDB) {
            fetchTaxGroups();
            fetchGeneralSettings();
        }
    }, [logginedDB]);

    const fetchTaxGroups = async () => {
        try {
            const response = await axios.get(`${apiBaseUrl}/getTaxGroups/${logginedDB}`);
            setTaxGroups(response.data || []);
        } catch (error) {
            console.error("Error fetching tax groups:", error);
        }
    };

    const fetchGeneralSettings = async () => {
        try {
            const response = await axios.get(`${apiBaseUrl}/api/settings/${logginedDB}`);
            if (response.data) {
                const settingsData = Array.isArray(response.data) ? response.data[0] : response.data;
                console.log(settingsData, "settingsData");
                if (settingsData.isTaxInclusive !== undefined) {
                    settingsData.isTaxInclusive = settingsData.isTaxInclusive ? 1 : 0;
                }
                setGenSettings(settingsData);
            }
        } catch (error) {
    console.error("Error fetching general settings:", error);
        }
    };

    const navigate = useNavigate(null)

    // useEffect(() => {
    //     if (companyDetails) {
    //         setCompanyInfo(companyDetails);
    //     }
    // }, [companyDetails]);

    const handleOnChangeInfo = (e, field) => {
        const val = e.target.value
        setCompanyInfo(prev => ({
            ...prev,
            [field]: val
        }))
    }

    const handleOnGenSettingsChange = (e, field) => {
        const val = e.target.type === 'checkbox' ? (e.target.checked ? 1 : 0) : e.target.value;
        setGenSettings(prev => ({
            ...prev,
            [field]: val
        }))
    }

    const fileInputRef = useRef(null);
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleDivClick = (e) => {
        e.stopPropagation()
        // Click the hidden file input element
        return fileInputRef.current.click();
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith("image/")) {
            setLoading(true); // Set loading to true when starting to load

            const reader = new FileReader();
            reader.onloadend = () => {
                const img = new Image();
                img.src = reader.result;

                // When the image is loaded, convert it to WebP format using Canvas
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.drawImage(img, 0, 0, img.width, img.height);

                    // Convert the canvas content to WebP format
                    canvas.toBlob(
                        (blob) => {
                            const webpFile = new File([blob], file.name.replace(/\.[^.]+$/, '.webp'), { type: 'image/webp' });
                            setImage(webpFile); // Set the WebP file to state
                            setPreview(URL.createObjectURL(webpFile)); // Preview the WebP image
                            setLoading(false); // Set loading to false after processing is done
                        },
                        'image/webp',
                        1 // Quality level (0.8 is 80% quality)
                    );
                };
            };
            reader.readAsDataURL(file);
        } else {
            alert("Please select a valid image file");
            event.target.value = ""; // reset file input
        }
    };

    const handleSubmitImg = async () => {
        const formData = new FormData();
        formData.append('details', JSON.stringify(companyInfo));
        formData.append('image', image);
        if (initialPrintPreview === companyInfo.PrintPreview) {
            console.log("no change occured");

        } else {
            console.log("change occured!");
            try {
                const response = await axios.get(
                    `${apiBaseUrl}/printPreview/${logginedDB}/${companyInfo.PrintPreview}`

                );
                if (response.status === 200) {
                    // console.log("Response:", response.data);
                    setInitialPrintPreview(companyInfo.PrintPreview);

                }
            } catch (error) {
            }
        }
        try {
            // Save Company Details
            const response = await axios.post(`${apiBaseUrl}/profileImg/${logginedDB}`, formData, {
                headers: {
                    'Content-Type': 'multipart/formData'
                }
            });

            // Save General Settings
            await axios.post(`${apiBaseUrl}/api/settings/${logginedDB}`, genSettings);

            if (response.status === 200) {
                toast.success("Settings Updated")
                window.location.reload()
            }
        } catch (error) {
            alert('Error updating settings: ' + error.message);
        }
    };

    const [accountSettings, setAccountSettings] = useState(false)
    const [companySettings, setCompanySettings] = useState(true)

    return (
        <div className='w-screen h-screen flex overflow-hidden'>
            <div className='w-full h-full overflow-hidden hidden sm:flex sm:flex-col'>
                <SherDineNav />
                <div className='w-full bg-[#f5f5f5] flex-grow flex gap-3 overflow-hidden'>
                    <div className='w-max h-full z-[9999]'>
                        <SideNav focus={'Settings'} />
                    </div>
                    <div className='w-full h-full flex flex-col pr-3 pl-0 pb-3 pt-0 gap-3 overflow-hidden'>
                        <div className="pr-3 h-max w-full bg-[#fff] borderBottom">
                            <TopRootDiv image={'Settings'} root={['Settings']} />
                        </div>
                        <div className='relative w-full h-full flex flex-col gap-3 p-2 font-nunito overflow-hidden'>
                            <div className='w-full h-full bg-[#fff] py-3 px-20 gap-20 flex justify-center items-center rounded-md overflow-hidden'>
                                <div className='flex justify-center items-start w-max h-full p-3'>
                                    <div className='w-max h-max rounded-full'>
                                        <div className={`relative flex w-[8rem] h-[8rem] justify-center items-center rounded-full object-cover border-[#8C8C8C] ${(!loading && (!preview || !companyInfo.img)) ? 'bg-[#D9D9D9]' : 'bg-white'}`}>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                ref={fileInputRef}
                                                style={{ display: 'none' }}
                                                onChange={(e) => handleImageChange(e)}
                                            />
                                            {loading ? (
                                                <div className="relative w-full h-full flex justify-center items-center rounded-full">
                                                    <svg className="absolute w-full h-full flex justify-center items-center">
                                                        {loading && (
                                                            <circle className="circle-progress" cx="50%" cy="50%" r="49.5%" />
                                                        )}
                                                    </svg>
                                                    <span className='text-[.9rem]'>Loading...</span>
                                                </div>
                                            ) : (preview || companyInfo.img) && (
                                                <div>
                                                    <img className='w-[8rem] h-[8rem] rounded-full object-cover' src={preview || companyInfo.img} alt="" />
                                                    <div
                                                        className='absolute top-0 right-0 p-1 rounded-bl-[.313rem] rounded-tr-[.313rem] bg-[#fff] cursor-pointer'
                                                        onClick={async (e) => {
                                                            e.stopPropagation();
                                                            setPreview(null);
                                                            setImage(null);

                                                            // Also clear the companyInfo image from state
                                                            setCompanyInfo(prev => ({ ...prev, img: null }));
                                                        }
                                                        }
                                                    >
                                                        <img className='w-[1rem]' src={cross} alt="Remove" />
                                                    </div>
                                                </div>
                                            )
                                            }
                                            <div className='absolute right-0 transform translate-x-0 translate-y-[150%] flex justify-center items-center rounded-full p-1 bg-[#fff] bg-opacity-85 cursor-pointer' onClick={
                                                handleDivClick
                                            }>
                                                <div className='flex justify-center items-center rounded-full p-[.4rem] bg-[#0008B4] bg-opacity-50'>
                                                    <img className='w-[.9rem]' src={cam} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='w-full h-full flex flex-col py-3 pl-3 gap-4 text-[1rem] overflow-hidden'>
                                    <div className='w-full h-max flex pr-3'>
                                        <div className={`px-3 py-2 flex justify-center items-center border-b-2 cursor-pointer ${companySettings ? 'border-[#0008B4] font-semibold' : 'border-b-2 border-[#fff] hover:border-[#ccc]'}`} onClick={() => {
                                            setAccountSettings(false)
                                            setCompanySettings(true)
                                        }}>Company Setting</div>
                                        <div className={`px-3 py-2 flex justify-center items-center border-b-2 cursor-pointer ${accountSettings ? 'border-[#0008B4] font-semibold' : 'border-b-2 border-[#fff] hover:border-[#ccc]'}`} onClick={() => {
                                            setAccountSettings(true)
                                            setCompanySettings(false)
                                        }}>Account Settings</div>
                                    </div>
                                    {companySettings && (
                                        <div className='w-full h-full flex flex-col gap-2 pr-3 text-[.95rem] overflow-auto customScroll'>
                                            <div className='w-full flex gap-3'>
                                                <div className='w-1/2 flex flex-col gap-1'>
                                                    <span>S Name</span>
                                                    <input type="text" className='p-2 border border-[#E6E6E6] text-[.9rem]' value={companyInfo.Sname || ''}
                                                        onChange={(e) => handleOnChangeInfo(e, 'sname')} />
                                                </div>
                                                <div className='w-1/2 flex flex-col gap-1'>
                                                    <span>Name</span>
                                                    <input type="text" className='p-2 border border-[#E6E6E6] text-[.9rem]' value={companyInfo.name || ''}
                                                        onChange={(e) => handleOnChangeInfo(e, 'name')} />
                                                </div>
                                            </div>
                                            <div className='w-full flex gap-3'>
                                                <div className='w-1/2 flex flex-col gap-1'>
                                                    <span>Address 1</span>
                                                    <input type="text" className='p-2 border border-[#E6E6E6] text-[.9rem]' value={companyInfo.add1 || ''}
                                                        onChange={(e) => handleOnChangeInfo(e, 'add1')} />
                                                </div>
                                                <div className='w-1/2 flex flex-col gap-1'>
                                                    <span>Address 2</span>
                                                    <input type="text" className='p-2 border border-[#E6E6E6] text-[.9rem]' value={companyInfo.add2 || ''}
                                                        onChange={(e) => handleOnChangeInfo(e, 'add2')} />
                                                </div>
                                            </div>
                                            <div className='w-full flex gap-3'>
                                                <div className='w-1/2 flex flex-col gap-1'>
                                                    <span>Address 3</span>
                                                    <input type="text" className='p-2 border border-[#E6E6E6] text-[.9rem]' value={companyInfo.add3 || ''}
                                                        onChange={(e) => handleOnChangeInfo(e, 'add3')} />
                                                </div>
                                                <div className='w-1/2 flex flex-col gap-1'>
                                                    <span>Email</span>
                                                    <input type="text" className='p-2 border border-[#E6E6E6] text-[.9rem]' value={companyInfo.email || ''}
                                                        onChange={(e) => handleOnChangeInfo(e, 'email')} />
                                                </div>
                                            </div>
                                            <div className='w-full flex gap-3'>
                                                <div className='w-1/2 flex flex-col gap-1'>
                                                    <span>Mobile</span>
                                                    <input type="text" className='p-2 border border-[#E6E6E6] text-[.9rem]' value={companyInfo.mobile || ''}
                                                        onChange={(e) => handleOnChangeInfo(e, 'mobile')} />
                                                </div>
                                                <div className='w-1/2 flex flex-col gap-1'>
                                                    <span>GST No.</span>
                                                    <input type="text" className='p-2 border border-[#E6E6E6] text-[.9rem]' value={companyInfo.gst || ''}
                                                        onChange={(e) => handleOnChangeInfo(e, 'gst')} />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {accountSettings && (
                                        <div className='w-full h-full flex flex-col gap-2 pr-3 text-[.95rem] overflow-auto customScroll'>
                                            <div className='AddCaptain_rights_div'>
                                                <div className='AddCaptain_rights_div_span'>Enable Print Preview</div>
                                                <div className='AddCaptain_rights_div_checkbox'>
                                                    <input
                                                        type="checkbox"
                                                        checked={companyInfo.PrintPreview === 1}
                                                        onChange={(e) => {
                                                            const value = e.target.checked ? 1 : 0;
                                                            setCheckboxValue(value);
                                                            setCompanyInfo(prev => ({
                                                                ...prev,
                                                                PrintPreview: value
                                                            }));
                                                        }} />
                                                    <span>YES</span>
                                                </div>
                                            </div>

                                            <div className='w-full flex flex-col gap-2 p-3 border rounded-md mt-2'>
                                                <div className='font-semibold border-b pb-1 mb-2'>Tax Settings</div>
                                                
                                                <div className='flex gap-3 items-center'>
                                                    <div className='flex flex-col gap-1 w-1/2'>
                                                        <span>Default Tax Group</span>
                                                        <select 
                                                            className='p-2 border border-[#E6E6E6] text-[.9rem]'
                                                            value={genSettings.Default_Tax_Id || ''}
                                                            onChange={(e) => handleOnGenSettingsChange(e, 'Default_Tax_Id')}
                                                        >
                                                            <option value="">Select Tax Group</option>
                                                            {taxGroups.map(tax => (
                                                                <option key={tax.id_tax} value={tax.id_tax}>{tax.name} ({tax.gstPercent}%)</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    
                                                    <div className='flex items-center gap-2 mt-4'>
                                                        <input 
                                                            type="checkbox" 
                                                            id="isTaxInclusive"
                                                            checked = {genSettings.isTaxInclusive === true || genSettings.isTaxInclusive === 1}
                                                            onChange={(e) => handleOnGenSettingsChange(e, 'isTaxInclusive')}
                                                        />
                                                        <label htmlFor="isTaxInclusive" className='cursor-pointer'>Tax is Inclusive</label>
                                                    </div>
                                                </div>

                                                <div className='flex gap-3 items-center mt-2'>
                                                    <div className='flex flex-col gap-1 w-1/2'>
                                                        <span>Tax Mode</span>
                                                        <select 
                                                            className='p-2 border border-[#E6E6E6] text-[.9rem]'
                                                            value={genSettings.Tax_Mode || 'ITEM_DETAIL'}
                                                            onChange={(e) => handleOnGenSettingsChange(e, 'Tax_Mode')}
                                                        >
                                                            <option value="ITEM_DETAIL">Item Level Detail</option>
                                                            <option value="BILL_LEVEL">Bill Level (Total)</option>
                                                            <option value="NONE">No Tax</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className='w-full h-max flex justify-end items-center gap-3 pr-3'>
                                        <button className='bg-[#fff] text-[#0008B4] loginBorder py-1 px-5 rounded-md' onClick={() => navigate('/')}>Cancel</button>
                                        <button className='bg-[#0008B4] text-[#fff] py-1 px-5 rounded-md' onClick={handleSubmitImg}>Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SoftwareSettings
